import React, { Component } from "react";
import { ReactComponent as PasswordIcon } from "./assets/padlock.svg";
import TextField from "@material-ui/core/TextField";
import { Button, CircularProgress } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";

const BlueTextField = withStyles({
  root: {
    "& .MuiInput-underline:before": {
      borderBottomColor: "#0099cc8", // Semi-transparent underline
    },
    "& .MuiInput-underline:hover:before": {
      borderBottomColor: "#0099cc", // Solid underline on hover
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#0099cc", // Solid underline on focus
    },
  },
})(TextField);

export default class Password extends Component {
  render() {
    const { password, error, validate, language, setPassword, loading } =
      this.props;
    return (
      <div>
        {" "}
        <div
          className="text-center"
          style={{ marginTop: 70, marginBottom: 40 }}
        >
          <PasswordIcon style={{ height: 100, width: 100 }} />
        </div>
        <p className="text-center bold">
          {language === "arabic"
            ? "الرجاء ادخال كلمة المرور"
            : "Please enter your password"}
        </p>
        <div style={{ marginBottom: 70, textAlign: "center" }}>
          <BlueTextField
            id="standard-password-input"
            label={language == "english" ? "Password" : "كلمة المرور"}
            type="password"
            autoComplete="current-password"
            className="mb-3 mt-3"
            style={{
              minWidth: 280,
              maxWidth: 400,
              direction: language == "english" ? "ltr" : "rtl",
            }}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            error={error && password.length > 0}
            helperText={
              error && password.length > 0
                ? language === "english"
                  ? "Incorrect password"
                  : "كلمة مرور خاطئة"
                : ""
            }
            FormHelperTextProps={{
              style: {
                textAlign: language == "english" ? "left" : "right",
              },
            }}
            InputLabelProps={{
              style: {
                transformOrigin:
                  language == "english" ? "top left" : "top right",
                right: language == "arabic" ? 0 : "unset",
                left: language == "english" ? 0 : "unset",
              },
            }}
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                validate();
              }
            }}
          />

          <div className="mt-3">
            <Button
              variant="contained"
              disabled={password.length == 0}
              color="primary"
              style={{
                width: 100,
                boxShadow: "none",
                fontWeight: "bold",
                textTransform: "none",
                fontSize: 14,
                backgroundColor: "#0099cc",
                color: "white",
              }}
              onClick={() => validate()}
            >
              {loading === false ? (
                language === "english" ? (
                  "Enter"
                ) : (
                  "دخول"
                )
              ) : (
                <CircularProgress
                  style={{ color: "white", width: 25, height: 25 }}
                />
              )}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
